// extracted by mini-css-extract-plugin
export default {"wrapper":"page_wrapper__ahKvG","status":"page_status__aFU37","video":"page_video__-m2j1"};